import React, { useMemo } from 'react';
import { MemoChart } from './MemoChart';
import { useThemeVersion } from '../../../useTheme';

// Mesma lógica de cor por acerto/erro/em branco usada em
// AttemptResultPieChart.js/ModuleBreakdownBarChart.js, aplicada por ponto
// (não pela linha inteira, que fica azul fixa).
const dotColor = (item) => {
    if (item.selectedChoiceId == null) return '#9E9E9E';
    return item.isCorrect ? '#22C55E' : '#EF4444';
};

export const QuestionTimeChart = ({ attemptItems }) => {
    const themeVersion = useThemeVersion();

    // item.order é a posição real que o aluno viu a questão (sincronizada
    // com PracticeTestAnswer); tentativas antigas sem esse dado caem pro
    // índice de chegada da API, como antes.
    const data = useMemo(() => attemptItems
        .map((item, index) => ({
            index: item.order ?? index + 1,
            minutes: item.timeSeconds != null ? Math.round((item.timeSeconds / 60) * 100) / 100 : null,
            selectedChoiceId: item.selectedChoiceId,
            isCorrect: item.isCorrect,
        }))
        .filter(d => d.minutes != null), [attemptItems]);

    const chartData = useMemo(() => ({
        labels: data.map(d => d.index),
        datasets: [{
            label: 'Tempo',
            data: data.map(d => d.minutes),
            borderColor: '#42A5F5',
            backgroundColor: data.map(d => dotColor(d)),
            pointBackgroundColor: data.map(d => dotColor(d)),
            pointRadius: 5,
            tension: 0.4,
        }],
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [data]);

    const chartOptions = useMemo(() => {
        const textColor = getComputedStyle(document.documentElement).getPropertyValue('--text-color');
        const gridColor = getComputedStyle(document.documentElement).getPropertyValue('--surface-border');
        return {
            maintainAspectRatio: false,
            layout: { padding: 12 },
            plugins: {
                legend: { display: false },
                tooltip: {
                    callbacks: {
                        title: (items) => `Questão ${items[0]?.label}`,
                        label: (context) => `${context.raw} min`,
                    },
                },
            },
            scales: {
                x: {
                    title: { display: true, text: 'Questão', color: textColor },
                    ticks: { color: textColor },
                    grid: { color: gridColor },
                },
                y: {
                    title: { display: true, text: 'min', color: textColor },
                    ticks: { color: textColor },
                    grid: { color: gridColor },
                },
            },
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [themeVersion]);

    if (data.length === 0) return null;

    return (
        <MemoChart type="line" data={chartData} options={chartOptions} style={{ height: '220px' }} />
    );
};
